import { render, staticRenderFns } from "./homepage-bfhs.vue?vue&type=template&id=0a32aeb0&scoped=true&"
import script from "./homepage-bfhs.vue?vue&type=script&lang=js&"
export * from "./homepage-bfhs.vue?vue&type=script&lang=js&"
import style0 from "./homepage-bfhs.vue?vue&type=style&index=0&id=0a32aeb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32aeb0",
  null
  
)

export default component.exports